import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Formik } from "formik";
import { object, string } from "yup";
import { apiService } from "../../service/api.service";
import { InlineLoader } from "../../components/loader";

import swal from "sweetalert";
import Swal from "sweetalert2";
import { useContext } from "react";
import { MyContext } from "../../config/config";
import { ThreeDotSpinner } from "../../components/loader";
import { useTranslation } from 'react-i18next';
import '../../i18n';
export const Login = () => {
  const { t } = useTranslation();

  const md5 = require('md5')
  const {affiliateRequest, setAffiliateRequest}=useContext(MyContext);
  const [loginObj, setLoginObj] = useState({
    email: "",
    password: "",
    role: "Admin"
  });
  const [loader, setLoader] = useState(false);
  const [type, setType] = useState("password");

  const requestFormSchema = object({
    email: string().email().required(t("email_req")).trim(),
    password: string().required(t("pass_req")).trim(),
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("admin_token")) {
      navigate("/Home");
    }else{

    }
    setAffiliateRequest(false)
  }, []);

  async function handleFormSubmit(value) {
    setLoader(true);
    try {

      const data={
        "email":value.email,
        "password":value.password,
        "role":"admin"
      }
     
      let response = await apiService.login(data);
      if ((response?.status == 200 || response?.status==201) && (response?.data)) {
        let responseData = response?.data.data.token
        let lang = response?.data.data.user.lang

        localStorage.setItem("phone",response?.data.data.user.phone);
        //  localStorage.setItem("admin_token",responseData);
         localStorage.setItem("lang",lang);
         
        setLoader(false);
        localStorage.setItem("login", true)
        localStorage.setItem("Id", responseData?.id)
        window.location.href = "/verify-otp"
       
        // swal(t("success"),t("login_success"), "success").then((value)=>{
        //   if(value){
        //     window.location.href = "/verify-otp"
        //   }
        // })
        
      }
    } catch (error) {
      setLoader(false);
      if(error?.response?.status == 400){
        
        swal({icon:"error", text: error?.response?.data?.message, button: "OK", }).then((value) => {
          console.log('OK button clicked after error alert')
        })
      }else{
        swal({icon:"error", text: error?.response?.data?.message ? error?.response?.data?.message: error?.message, button: "OK", }).then((value) => {
          console.log('OK button clicked after error alert')
        })
      }
      
    }
  }

  function FormikErrorMessage(props) {
    return (
      <label id="uname-error" className="text-danger" for={props.for}>
      
        { props.message[0].toUpperCase() + props.message.slice(1).toLowerCase()}
      </label>
    );
  }

  return (
    <>
     
      <div className="login-area">
      {loader ? <ThreeDotSpinner className="loginPageLoader" /> : ""}
       <div className="curve-top"></div>
        <div className="curve-bottom"></div>
        <div className="dots-left"></div>
         <div className="dots-right"></div>
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={8} xl={6}>
              <div className="logo-top">
                <img
                  src={require("../../assets/images/front-logo.png")}
                  alt="logo"
                />
              </div>
              <div className="login-content-area">
                <h2>{t("login")}</h2>
                <p>{t("enter_email_pass")}</p>
                <Formik
                  initialValues={loginObj}
                  validationSchema={requestFormSchema}
                  enableReinitialize={true}
                  onSubmit={(values) => {
                        setLoader(true);
                        handleFormSubmit(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <Form autoComplete="off" onSubmit={handleSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("email")}</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder={t("enter_email")}
                          id="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                        />
                        {errors.email && touched.email ? (
                          <FormikErrorMessage
                            for="email"
                            message={errors.email}
                          />
                        ) : null}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("pass")}</Form.Label>
                        <div className="password-area">
                        <Form.Control
                          type={type}
                          placeholder={t("enter_pass")}
                          id="password"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          />
                          {type == "password"?
                          <i class="fa fa-eye"  style={{cursor:"pointer"}} aria-hidden="true" onClick={()=>setType("text")}></i>:
                          <i class="fa fa-eye-slash" style={{cursor:"pointer"}} aria-hidden="true" onClick={()=>setType("password")}></i>}
                        </div>
                   
                        {errors.password && touched.password ? (
                          <FormikErrorMessage
                            for="password"
                            message={errors.password}
                          />
                        ) : null}
                      </Form.Group>
                      <Button variant="primary" type="submit" className="login-btn-submit">
                        {loader ? <InlineLoader /> : t("login")}
                      </Button>
                    </Form>
                  )}
                </Formik>
              </div>
            </Col>
          </Row>
        </Container>
        
      </div>
    </>
  );
};
